module.exports = __webpack_public_path__ + "img/framework.85fe2029.jpg";